import { useEffect } from 'react'

interface SeoProps {
  title: string
  description: string
  path?: string
}

export function useSeo({ title, description, path }: SeoProps) {
  useEffect(() => {
    document.title = title

    const setMeta = (attr: string, attrValue: string, content: string) => {
      let el = document.head.querySelector<HTMLMetaElement>(
        `meta[${attr}="${attrValue}"]`,
      )
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attr, attrValue)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    }

    setMeta('name', 'description', description)
    setMeta('property', 'og:title', title)
    setMeta('property', 'og:description', description)
    setMeta('property', 'og:type', 'website')
    setMeta(
      'property',
      'og:image',
      'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https%3A//assets.cdn.filesafe.space/cMkAnz3QfJpQ1Lp2u0QG/media/69160e581547ed5536c65e53.jpg',
    )
    setMeta('name', 'twitter:card', 'summary_large_image')

    if (path) {
      let canonical = document.head.querySelector<HTMLLinkElement>(
        'link[rel="canonical"]',
      )
      if (!canonical) {
        canonical = document.createElement('link')
        canonical.setAttribute('rel', 'canonical')
        document.head.appendChild(canonical)
      }
      canonical.setAttribute('href', `https://www.fsgtransport.com${path}`)
    }

    // NOTE: The favicon cannot be set via code here.
    // Please upload the FSG Transport favicon via the "Publish" button.
  }, [title, description, path])
}
